export default __webpack_public_path__ + "static/media/chargerPlugIcon.73eb4850.png";